import {notification} from 'antd';

export const signInEmailOrPasswordIncorrect = type => {
    notification[type]({
        message: 'შეცდომა',
        description: 'ელ-ფოსტა ან პაროლი არასწორია',
    });
};
